export default {"src":"/_next/static/media/base_ball.d071a546.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};